<template>
    <div class="login">
         <div class="box">
             <h3 class="title">请登录</h3>
             <div class="form">
                 <el-input placeholder="请输入账号" prefix-icon="el-icon-warning" v-model="username"></el-input>
                 <el-input type="password" placeholder="请输入密码" prefix-icon="el-icon-warning" style="margin-top: 15px;" v-model="password"></el-input>
                 <el-button type="primary" style="width: 100%; margin-top: 20px;" @click="submit" :loading="loading">登 录</el-button>
             </div>
         </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            username: '',
            password: '',
            code: '',
            loading: false,
        }
    },
    created() {
        localStorage.removeItem('token');
    },
    methods: {
        async submit() {
            if(!this.username) {
                this.$message.error('请填写账号');
                return false;
            } else if(!this.password) {
                this.$message.error('请填写密码');
                return false;
            }

            this.loading = true;
            const res = await this.$api.login({
                username: this.username,
                password: this.password
            });
            this.loading = false;
            if(res.data.code == 0) {
                localStorage.setItem('token', res.data.data);
                this.$message({
                    type: 'success',
                    message: '登录成功'
                });
                this.$router.push('/');
            } else {
                this.$message.error(res.data.msg);
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .login {
        width: 100vw;
        height: 100vh;
        background-color: #2d3a4b;
        display: flex;
        justify-content: center;
        align-items: center;

        .box {
            background-color: #fff;
            border-radius: 6px;
            box-shadow: 0 0 10px 0 rgba(0, 0, 0, .1);
            text-align: center;
            padding: 20px;
            width: 350px;

            .title {
                font-weight: normal;
                font-size: 20px;
            }

            .form {
                margin-top: 20px;
            }
        }
    }
</style>
